export const WEEK_START_ON = 1 as const;
export const WEEK_OPTIONS = { weekStartsOn: WEEK_START_ON } as const;
